// extracted by mini-css-extract-plugin
export default {"agentAgencyInfoItem":"agentAgencyInfoItem_mlSmh","subtitle":"subtitle_tA84j"};